export enum MediaSource {
  AD_VIDEO = 'AD_VIDEO',
  AD_IMAGE = 'AD_IMAGE',
  CATEGORY_IMAGE = 'CATEGORY_IMAGE',
  CONCERT_BACKGROUND = 'CONCERT_BACKGROUND',
  CONCERT_POSTER = 'CONCERT_POSTER',
  DOCUMENTARY_BACKGROUND = 'DOCUMENTARY_BACKGROUND',
  DOCUMENTARY_POSTER = 'DOCUMENTARY_POSTER',
  COUNTRY_FLAG = 'COUNTRY_FLAG',
  HOME_SLIDE = 'HOME_SLIDE',
  MOVIE_BACKGROUND = 'MOVIE_BACKGROUND',
  MOVIE_POSTER = 'MOVIE_POSTER',
  WATERMARK_IMAGE = 'WATERMARK_IMAGE',
  RADIO_IMAGE = 'RADIO_IMAGE',
  TV_SHOW_BACKGROUND = 'TV_SHOW_BACKGROUND',
  TV_SHOW_POSTER = 'TV_SHOW_POSTER',
  SPORT_BACKGROUND = 'SPORT_BACKGROUND',
  SPORT_POSTER = 'SPORT_POSTER',
  TV_LOGO = 'TV_LOGO',
}
